import { type DocumentSummary } from '../../services/api/documents';

export const buildDownloadUrl = (url: string) => {
  if (!url) {
    return '#';
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  return url.startsWith('/') ? url : `/${url}`;
};

export const formatFileSize = (bytes?: number) => {
  if (typeof bytes !== 'number' || Number.isNaN(bytes) || bytes <= 0) {
    return undefined;
  }

  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
};

export const formatTimestamp = (iso?: string) => {
  if (!iso) {
    return undefined;
  }

  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return undefined;
    }
    return new Intl.DateTimeFormat('sv-SE', {
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(date);
  } catch {
    return undefined;
  }
};

export const getDocumentMeta = (document: DocumentSummary) => {
  return [
    document.originalFilename,
    formatFileSize(document.size),
    formatTimestamp(document.createdAt),
  ]
    .filter(Boolean)
    .join(' • ');
};
